import { ISVGProps } from '@alinta-digital/asg';
import React from 'react';

export const GeneralSystemErrorIllustration = (props: ISVGProps) => (
  <svg viewBox="0 0 361 373" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M251 334.1C251 334.1 215.9 318.5 157.5 318.5C98.3 318.5 57.1 332.2 57.1 332.2C57.1 332.2 76.3 334.9 82.9 336.9C89.5 338.9 139.8 353.5 164.2 350C164 350.3 210.5 334.1 251 334.1Z"
      fill="#F26722"
    />
    <path
      opacity="0.1"
      d="M82.8 325.9C100.7 322.4 126.4 318.6 157.3 318.6C215.7 318.6 250.8 334.2 250.8 334.2C250.8 334.2 275.5 330.5 300.5 334.8C337.3 304.7 360.6 259 360.6 207.8C360.6 117.2 287 43.6 196.4 43.6C105.8 43.6 32.6 117.1 32.6 207.7C32.6 254.1 51.8 296.1 82.8 325.9Z"
      fill="#00A7E6"
    />
    <path
      d="M167.6 173.7L123.2 117.5C122.9 117 122.1 117.5 122.3 118L142.4 166.8L163.5 176.1L167.6 173.7Z"
      fill="white"
    />
    <path
      d="M153.8 208.4C159.047 208.4 163.3 204.147 163.3 198.9C163.3 193.653 159.047 189.4 153.8 189.4C148.553 189.4 144.3 193.653 144.3 198.9C144.3 204.147 148.553 208.4 153.8 208.4Z"
      fill="white"
    />
    <path d="M150.2 208.4L140 219.5L88.7001 227C88.1001 227.2 87.8 226.1 88.4 225.9L143.6 200.9" fill="white" />
    <path d="M163.1 196L178.1 198.1L212.6 235.8C213.2 236.4 212.4 237.3 211.7 236.9L160.6 205.8" fill="white" />
    <path d="M157.3 207.6L159 317.6H146.9L150.9 207.7C150.9 207.7 154.1 209.6 157.3 207.6Z" fill="white" />
    <path
      d="M162.3 107.9C164.399 107.9 166.1 106.199 166.1 104.1C166.1 102.001 164.399 100.3 162.3 100.3C160.201 100.3 158.5 102.001 158.5 104.1C158.5 106.199 160.201 107.9 162.3 107.9Z"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M162.3 100.3V63.1" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M162.3 107.9L133.6 130.7" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M162.3 107.9L162.8 167.8" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path
      d="M170.4 63.1H154.2C153.3 63.1 152.5 62.3 152.5 61.4V54.4C152.5 53.5 153.3 52.7 154.2 52.7H170.4C171.3 52.7 172.1 53.5 172.1 54.4V61.4C172.1 62.5 171.3 63.1 170.4 63.1Z"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M234.9 328.9V52.7" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M251 333.6V52.7" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M295.2 35.2999H277.8V52.6999H295.2V35.2999Z" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path
      d="M277.8 52.7H133.2C131.2 52.7 130.1 50.3 131.7 48.7L143.8 37.1H277.9V52.7H277.8Z"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M234.9 37.2999V16.7999H251V37.2999" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path
      d="M251 16.8L244 1.69998C243.7 0.899976 242.5 0.899976 242 1.69998L235 16.8"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M295.2 35.2999L243.3 1.39995C243 1.19995 242.7 1.19995 242.4 1.19995L143.7 37.0999"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M143.8 37.3001L157.1 51.8001C157.6 52.4001 158.5 52.4001 159.1 51.8001L172.8 38.2001C173.4 37.6001 174.2 37.7001 174.8 38.2001L187.2 51.6001C187.7 52.2001 188.6 52.2001 189.2 51.6001L202.9 38.0001C203.5 37.4001 204.3 37.5001 204.9 38.0001L217.3 51.4001C217.8 52.0001 218.7 52.0001 219.3 51.4001L233 37.9001C233.6 37.3001 234.4 37.4001 235 37.9001L247.4 51.3001C247.9 51.9001 248.8 51.9001 249.4 51.3001L263 37.7001C263.6 37.1001 264.4 37.2001 265 37.7001L278.3 52.2001"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M234.9 52.7L249.4 67.2C250.2 68 250 69 249.4 69.8L236.3 81.9C235.7 82.4 235.7 83.3 236.3 83.9L249.9 97.6C250.5 98.2 250.4 99 249.9 99.6L236.5 112C235.9 112.5 235.9 113.4 236.5 114L250.1 127.7C250.7 128.3 250.6 129.1 250.1 129.7L236.6 142C236 142.5 236 143.4 236.6 144L250.2 157.7C250.8 158.3 250.7 159.1 250.2 159.7L236.8 172C236.2 172.5 236.2 173.4 236.8 174L250.4 187.7C251 188.3 250.9 189.1 250.4 189.7L237.1 201.9C236.5 202.5 236.5 203.4 237.1 204L250.4 217.3C251 217.9 251 218.8 250.4 219.4L237.3 233.6C236.4 234.5 236.4 236 237.3 237L250.1 249.8C250.9 250.6 250.7 251.6 250.1 252.4L237 264.5C236.4 265 236.4 265.9 237 266.5L250.6 280.2C251.2 280.8 251.1 281.6 250.6 282.2L237.2 294.6C236.6 295.1 236.6 296 237.2 296.6L250.8 310.3C251.4 310.9 251.3 311.7 250.8 312.3L237.4 324.7"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M167.6 173.7L123.2 117.5C122.9 117 122.1 117.5 122.3 118L142.4 166.8L163.5 176.1L167.6 173.7Z"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M153.8 208.4C159.047 208.4 163.3 204.147 163.3 198.9C163.3 193.653 159.047 189.4 153.8 189.4C148.553 189.4 144.3 193.653 144.3 198.9C144.3 204.147 148.553 208.4 153.8 208.4Z"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M150.2 208.4L140 219.5L88.7 227C88.1 227.2 87.8 226.1 88.4 225.9L143.6 200.9"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M163.1 196L178.1 198.1L212.6 235.8C213.2 236.4 212.4 237.3 211.7 236.9L160.6 205.8"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M157.3 207.6L158.9 317.6" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M150.9 207.7L146.9 317.6" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path
      d="M308.8 335.3C308.8 335.3 205.9 319.6 117.9 371.5"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M273.9 349.8C245.1 349.5 201.7 352.9 157.8 369.2"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M292.5 350.4C290.2 350.2 287.6 350.1 285 349.9"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M84.8 337.2C38.3 325.9 0.700012 330.3 0.700012 330.3"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M162.9 350.6C154.4 351.2 133.1 350.8 95.6 339.9"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M112.4 359.1C112.4 359.1 94.5 355.4 87.2 353.8C79.7 352 62 348.5 62 348.5"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M49.4 346.5C49.4 346.5 41.2 345.4 35.7 345.3"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M216.3 337.3C216.3 337.3 185 332.9 162.7 333.3"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M155 333.3H148.6" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M108.6 322.5C79.5 326.5 56.9 332 56.9 332" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path
      d="M187.5 320.4C176.5 319.2 165.1 318.4 153.8 318.7C141.4 319 128.9 320.1 117.2 321.4"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path
      d="M250.8 333.2C250.8 333.2 230.7 326.9 203.9 322.7"
      stroke="#43363D"
      strokeWidth="1.4296"
      strokeMiterlimit="10"
    />
    <path d="M227.5 275.7H173.7" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M115.8 186.2H66.3" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M53.6 186.2H36.7" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M135.3 159.1H112.6" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M207.2 159.1H178.2" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M132.8 275.7H118.4" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
    <path d="M223.6 159.1H215.9" stroke="#43363D" strokeWidth="1.4296" strokeMiterlimit="10" />
  </svg>
);
